import { render } from "./NewOrderIndustrial.vue?vue&type=template&id=6fab3574&scoped=true"
import script from "./NewOrderIndustrial.vue?vue&type=script&lang=js"
export * from "./NewOrderIndustrial.vue?vue&type=script&lang=js"

import "./NewOrderIndustrial.vue?vue&type=style&index=0&id=6fab3574&lang=css"
import "./NewOrderIndustrial.vue?vue&type=style&index=1&id=6fab3574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fab3574"]])

export default __exports__